import { FormField } from "../../../../actions/Tenants/config/constantsTyped";
import { Form } from "../PageBase";
import { Grower, GrowerFormObject } from "./types";

const generateName = (label: string) => label.toLowerCase().replace(/ /g, "-");

export const definedGrowerFormCreate = (onSaveGrower: (grower: Grower) => void, onDeleteGrower: (id: string) => void) => (_formOptions: any, entity: Partial<Grower> | undefined) => {
    const nameField: FormField = {
        label: "Identifier",
        name: "name",
        type: "text",
        disabled: true,
    };

    const baseForm: FormField[] = [
        {
            label: "Grower Name",
            name: "label",
            type: "text",
            mandatory: true,
            pattern: "^(?!\\s*$).+$",
            invalid_hint: "String consists of spaces is not allowed",
        },
        {
            label: "Country",
            name: "country",
            type: "select-managed",
            mandatory: true,
        },
        {
            label: "Fruit(s)",
            name: "fruit_type",
            type: "select-managed",
            mandatory: true,
            multi: true,
            return_array: true,
        },
        {
            label: "GGN",
            name: "ggn",
            type: "text",
            mandatory: true,
        }
    ];

    const growerForm: FormField[] = entity?.id
        ? [nameField, ...baseForm]
        : baseForm;

    const onSave = (formObject: GrowerFormObject, entity: Partial<Grower>) => {
        const grower: any = {
            ...entity,
            ...formObject,
            fruit_types: formObject.fruit_type,
            fruit_type: undefined,
            name: entity.name || generateName(formObject.label),
        };

        onSaveGrower(grower as Grower);
    };

    const onDelete = (_: GrowerFormObject, entity: Partial<Grower>) => {
        onDeleteGrower(entity.id!);
    };

    const getFormObjectFromEntity = (entity: Partial<Grower>): Partial<GrowerFormObject> => {
        return {
            ...entity,
            fruit_type: entity.fruit_types || [],
            name: entity.name,
        };
    };

    const growerModal: Form<GrowerFormObject, Grower> = {
        title: "Grower",
        fields: growerForm,
        modalButtonLabel: "Edit",
        onSave,
        onDelete,
        getFormObjectFromEntity
    };

    return growerModal;
};
